import * as React from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";

import Icon from "./Icon";

const styles = require("./styles.module.scss");

interface IProps {
  text: string | any;
  title?: string;
  className?: string;
  position?: string; // position of "?" icon
  iconTheme?: "dark" | "grey";
  placement?: "top" | "right" | "bottom" | "left"; // https://react-bootstrap.github.io/components/overlays/#popovers
}

const LearnMore: React.SFC<IProps> = ({
  title,
  text,
  className,
  position,
  iconTheme,
  placement,
}) => {
  const id = `id-${Math.random()}`;
  const popover = (
    <Popover id={id}>
      <div className={styles.popoverTitle}>
        <Icon position="before" theme={iconTheme} />
        <strong>{title}</strong>
      </div>
      {/* tslint:disable react/no-danger */}
      <div className={styles.popoverText} dangerouslySetInnerHTML={{ __html: text }} />
      {/* tslint:enable */}
    </Popover>
  );

  return (
    <OverlayTrigger placement={placement || "top"} trigger={["hover", "focus"]} overlay={popover}>
      <span className={className}>
        <Icon position={position} theme={iconTheme} />
      </span>
    </OverlayTrigger>
  );
};

export default LearnMore;
